import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('modules.media', {
            url: '/media',
            templateUrl: 'views/modules/media/media.html',
            controller: 'mediaController',
            redirectTo: 'modules.media.medias',
            data: {
              title: 'MEDIAS',
              permissions: {
                only: ['ADMIN', 'ExportMedia'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'mediaService',
            },
          })
          .state('modules.media.medias', {
            url: '/medias',
            templateUrl: 'views/modules/media/mediaList.html',
            controller: 'mediaListController',
            data: {
              title: 'MEDIAS',
              states: {
                new: 'modules.media.medias-new',
                media: 'modules.media.medias',
              },
              permissions: {
                only: ['ADMIN', 'ExportMedia'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'mediaService',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
